import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InternetBankSvgModule } from '../ib-svg/ib-svg.module';

import { DevToolsComponent } from './dev-tools.component';

export const devToolsModuleConfig = new InjectionToken<DevToolsConfig>('DevToolsConfig');

export interface DevToolsConfig {
	proxyConfigPath: string;
}

@NgModule({
	imports: [
		CommonModule,
		InternetBankSvgModule,
		ReactiveFormsModule,
		DragDropModule,
	],
	declarations: [DevToolsComponent],
	exports: [DevToolsComponent],
})
export class DevToolsModule {
	// public static forRoot(config: DevToolsConfig): ModuleWithProviders<DevToolsModule> {
	// 	return {
	// 		ngModule: DevToolsModule,
	// 		providers: [
	// 			{ provide: devToolsModuleConfig, useValue: config },
	// 		],
	// 	};
	// }
}
